import React, { useState, useRef, useEffect } from 'react';
import './Login.css';

function Login({ onLogin }) {
  var session = useRef(null);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [verificationCode, setVerificationCode] = useState('');
  const [isCodeSent, setIsCodeSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const expireAt = parseInt(sessionStorage.getItem("tokenExpiresAt"), 10);
    const now = Date.now();
    const accessToken = sessionStorage.getItem("accessToken")
    if(accessToken && expireAt > now) {
      onLogin(true);
    }
  }, []);

  const handlePhoneNumberChange = (e) => {
    const input = e.target.value.replace(/[^0-9]/g, '');
    if (input.length <= 11) {
      setPhoneNumber(input);
    }
  };

  const formatPhoneNumber = (number) => {
    if (!number) return '';
    if (number.startsWith('0')) {
      return '+82' + number.substring(1);
    }
    return number;
  };

  const handleVerificationCodeChange = (e) => {
    setVerificationCode(e.target.value);
  };

  const handleSendCode = async () => {
    if (!phoneNumber || phoneNumber.length !== 11) {
      setError('올바른 전화번호를 입력해주세요.');
      return;
    }

    try {
      setLoading(true);
      setError(null);
      const formattedPhoneNumber = formatPhoneNumber(phoneNumber);
      const response = await fetch('https://y51truxn5h.execute-api.ap-northeast-2.amazonaws.com/drimmAuth/AUTH_v1/init', {
        method: 'POST',
        body: JSON.stringify({
            phone_number: formattedPhoneNumber,
            client_id: "6av9ihkel1gtrt8ouoar0h683m",
            client_secret: "e7f73lf5blo54k8fh0gkk7utbmfp4kgfqseglmf4qtfm8qop5tt",
            user_pool_id: "ap-northeast-2_u5Pei5YTH" })
      });
      if (!response.ok) {
        throw new Error('데이터를 불러오는데 실패했습니다.');
      }

    
      const data = await response.json();
      session.current = data.session;
      
      setIsCodeSent(true);
    } catch (err) {
      setError('인증번호 발송에 실패했습니다.');
    } finally {
      setLoading(false);
    }
  };

  const handleVerify = async () => {
    if (!verificationCode) {
      setError('인증번호를 입력해주세요.');
      return;
    }

    try {
      setLoading(true);
      setError(null);
      const formattedPhoneNumber = formatPhoneNumber(phoneNumber);
      const response = await fetch('https://y51truxn5h.execute-api.ap-northeast-2.amazonaws.com/drimmAuth/AUTH_v1/confirm', {
        method: 'POST',
        body: JSON.stringify({
            phone_number: formattedPhoneNumber,
            confirmation_code: verificationCode,
            session: session.current,
            client_id: "6av9ihkel1gtrt8ouoar0h683m",
            client_secret: "e7f73lf5blo54k8fh0gkk7utbmfp4kgfqseglmf4qtfm8qop5tt",
            user_pool_id: "ap-northeast-2_u5Pei5YTH" })
      });
      if (!response.ok) {
        throw new Error('데이터를 불러오는데 실패했습니다.');
      }

    
      const data = await response.json();
      if (data.statusCode === 200) {
        onLogin(true);
        sessionStorage.setItem("accessToken", data.response.AuthenticationResult.AccessToken);
        //console.log("accessToken: " + sessionStorage.getItem("accessToken"))
        const currentTime = Date.now()
        const expireAt = currentTime + data.response.AuthenticationResult.ExpiresIn * 1000
        sessionStorage.setItem("tokenExpiresAt", expireAt.toString())
        //console.log(data.response)
      } else {
        session.current = data.session
        setError('인증번호가 올바르지 않습니다.');
      }
      
    } catch (err) {
      setError('인증번호가 올바르지 않습니다.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <h2>로그인</h2>
      {error && <p className="error">{error}</p>}
      <div className="input-group">
        <input
          type="tel"
          value={phoneNumber}
          onChange={handlePhoneNumberChange}
          placeholder="전화번호를 입력하세요 (예: 01012345678)"
          disabled={isCodeSent}
        />
        {!isCodeSent && (
          <button onClick={handleSendCode} disabled={loading}>
            인증번호 발송
          </button>
        )}
      </div>
      {isCodeSent && (
        <div className="input-group">
          <input
            type="text"
            value={verificationCode}
            onChange={handleVerificationCodeChange}
            placeholder="인증번호를 입력하세요"
          />
          <button onClick={handleVerify} disabled={loading}>
            확인
          </button>
        </div>
      )}
      {loading && <p className="loading">처리중...</p>}
    </div>
  );
}

export default Login; 